import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {  Cookies } from 'react-cookie';
import ChangePartnerRequest from './ChangePartnerRequest';
import ChangePartnerReject from './ChangePartnerReject';
import ChangePartnerActive from './ChangePartnerActive';



const styles = theme => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
  , paper: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(20),
      },
    },


});

class ChangePartner extends Component {
  cookies=new Cookies();
  constructor(props) {
      super(props);
    this.state = {
  value:0,
}}

componentDidMount() {

}
handleChange= (event,newValue) => {
  this.setState({ value:newValue });
}
    render() {
      const { classes } = this.props;
      const { value } = this.state;

        return (
            <div>
                 <AppBar position="sticky"color="primary" >

                   <Tabs
                    style={{height:'60px',textAlign:'center'}}
                     value={value}
                     onChange={this.handleChange}
                     indicatorColor="secondary"
                     textColor={'#000000'}
                     variant="scrollable"
                     scrollButtons="auto"
                     aria-label="scrollable auto tabs example"
                   >
                     <Tab label="درخواست های بررسی نشده"  />
                     <Tab label="درخواست های بررسی شده"  />
                     <Tab label="درخواست های رد شده"  />

                     </Tabs>


                 </AppBar>
                 {(value===0)?<ChangePartnerRequest  props={this.props}/>:null}
                 {(value===1)?<ChangePartnerActive  props={this.props}/>:null}
                 {(value===2)?<ChangePartnerReject  props={this.props}/>:null}


               </div>
        );
    }
}

export default  withStyles(styles)(ChangePartner);
